export const environment = {
    production: false,
    useEmulators: false,
    appName: "de.diwima.rcweb.dev",
    firebaseConfig: {
        apiKey: "AIzaSyBpaaJgIdwx7KYRG3pBGLcrvZjwsAA9yHk",
        authDomain: "diwima-de-dev-286115.firebaseapp.com",
        databaseURL: "https://diwima-de-dev-286115.firebaseio.com",
        projectId: "diwima-de-dev-286115",
        storageBucket: "diwima-de-dev-286115.appspot.com",
        messagingSenderId: "438434938454",
        appId: "1:438434938454:web:870093fa2eb3df1a3205f7"
    },
    appPostFix: '-Dev',
    mapBoxToken: "pk.eyJ1IjoiemlmZmVyZWlucyIsImEiOiJja2dhdTlmOGcwYXNzMnRwZDR3cXpkY2thIn0.pMsxXRhLz448Ne2BBiXdxg",
    mapBoxStyleOutdoors: "mapbox://styles/ziffereins/cmam7y4pl01fj01s4bcnz57e7",
    mapBoxStyleStreets: "mapbox://styles/ziffereins/ckgatv0ee162y19o2mc7i3uus",
    versionNumber: "1.3.21", 
    versionCode: 74,
    apiURL: "https://europe-west1-diwima-de-dev-286115.cloudfunctions.net/app/v1",
    invitationURL: "https://pub-invitation-dev.web.app"
}